export const isMobile = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(ua)) {
    return true;
  }

  // iOS detection
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return true;
  }

  return false;
};
export const isIOS = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  // iOS detection
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return true;
  }

  return false;
};
export const isAndroid = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  // iOS detection
  if (/android/i.test(ua)) {
    return true;
  }

  return false;
};